import { Spinner, Text, VStack, Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";

const AppLoader = () => {
  const loading = useSelector((state) => state.utils.loading);
  if (!loading) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      w="100vw"
      h="100vh"
      zIndex={9999}
      bg="rgba(255, 255, 255, 0.6)"
      backdropFilter="blur(4px)"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <VStack>
        <Spinner size="xl" />
        <Text>Loading...</Text>
      </VStack>
    </Box>
  );
};

export default AppLoader;
